/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import MetricsContext from './MetricsContext';
import commands from './commands';

export default (): Element<string> => {
  const ctx = useContext(MetricsContext);
  return (
    <div
      css={css(`
    display: grid;
    align-items: center;
    justify-items: center;
    height: 80%;
    button { color: #666; text-decoration: none; }
  `)}
    >
      <div>
        <button
          onClick={() => {
            commands(ctx).startCustomizing();
          }}
        >
          <i className="fas fa-hand-pointer" /> Get Started
        </button>
      </div>
    </div>
  );
};
